module.exports = __webpack_public_path__ + "img/bg02s.a3638010.jpg";